import { createContext } from "react";

export const UploadLightboxFileManagerContext = createContext({
    states: {
        fileUrl: '',
        isFileSelectVisible: false,
        uploading: false,
    },
    setStates: {
        setFileUrl: null,
        setIsFileSelectVisible: null,
        setUploading: null,
    },
    props: {
        //antd
        onChange: null,
        // parent
        fileTypeFilter: 'IMAGE',
        disabled: false,
        overrideUploadProps: null,
        openFileManagerOnClick: false,
        acceptedMimes: '',
        initialFileUrl: '',
        onUpload: null,
    },
    lightboxRef: {current: null},
});

export const UploadLightboxProvider = UploadLightboxFileManagerContext.Provider;
